import { useHttp } from '@/api'
import { httpApi } from '@/api/api'

/**
 * 意先月度別受注金額の検索
 */
export function SearchCusMOrderAmountData(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchCusMOrderAmountData,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 年間発注実績データの検索
 */
export function SearchAnnualOrdersData(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchAnnualOrdersData,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
